"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Enscape WebStandalone API - 1.0.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminApiApi = void 0;
const runtime = __importStar(require("../runtime"));
/**
 *
 */
class AdminApiApi extends runtime.BaseAPI {
    /**
     */
    apiDeleteProjectPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.id !== undefined) {
                formParams.append('id', new Blob([JSON.stringify(requestParameters.id)], { type: "application/json", }));
            }
            const response = yield this.request({
                path: `/api/delete_project`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiDeleteProjectPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiDeleteProjectPostRaw(requestParameters);
        });
    }
    /**
     */
    apiEditProjectPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.id !== undefined) {
                formParams.append('id', new Blob([JSON.stringify(requestParameters.id)], { type: "application/json", }));
            }
            if (requestParameters.licenseId !== undefined) {
                formParams.append('licenseId', requestParameters.licenseId);
            }
            if (requestParameters.userId !== undefined) {
                formParams.append('userId', requestParameters.userId);
            }
            const response = yield this.request({
                path: `/api/edit_project`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiEditProjectPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEditProjectPostRaw(requestParameters);
        });
    }
    /**
     */
    apiGetBundleIdGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiGetBundleIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/get_bundle/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiGetBundleIdGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiGetBundleIdGetRaw(requestParameters);
        });
    }
    /**
     */
    apiGetProjectsGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.query !== undefined) {
                queryParameters['query'] = requestParameters.query;
            }
            if (requestParameters.chunkSize !== undefined) {
                queryParameters['chunkSize'] = requestParameters.chunkSize;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/get_projects`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    apiGetProjectsGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGetProjectsGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGetRawIdGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiGetRawIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/get_raw/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiGetRawIdGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiGetRawIdGetRaw(requestParameters);
        });
    }
    /**
     */
    apiGetStatisticsGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.statistic !== undefined) {
                queryParameters['statistic'] = requestParameters.statistic;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/api/get_statistics`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiGetStatisticsGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiGetStatisticsGetRaw(requestParameters);
        });
    }
}
exports.AdminApiApi = AdminApiApi;
//# sourceMappingURL=AdminApiApi.js.map